import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import AudioListStore from './components/audio-list/store';
import AudioControllerStore from './components/audio-controller/store';
import PageLayoutStore from '@src/business-components/page-layout/store';
import routeConfigs from '@src/pages/app-router/route-configs';
import { getOmniData, AuditionVideoChannelId, AuditionAudioId } from '@src/services/omni-api';
import aos from '@src/utils/aos';
import { observable } from 'mobx';
import { HIDE_DATA } from '@src/constants/urls';

class AuditionAudioStore extends BaseStore {
  @observable hideData = HIDE_DATA;

  pageLayoutStore = new PageLayoutStore({
    type: '视听中心',
    breadcrumbNavItems: [
      {
        label: '官网首页',
        path: routeConfigs.MAIN.getFormatPath({ part: 'media' })
      },
      {
        label: '音乐'
      }
    ],
    isHideStrategy: () => this.hideData
  });
  isHideTopMenu = false;

  delayPlayAudioTimer = null;
  audioListStore = new AudioListStore({
    onSelect: (audio, index) => {
      clearTimeout(this.delayPlayAudioTimer);
      this.audioControllerStore.select(index);
      this.delayPlayAudioTimer = setTimeout(() => {
        this.audioControllerStore.playAudio(true);
      }, 100);
    }
  });

  audioControllerStore = new AudioControllerStore({
    onSelect: (audio, index) => {
      clearTimeout(this.delayPlayAudioTimer);
      this.audioListStore.select(index);
    }
  });

  // 在AuditionAudioStore中修改fetchAudioDuration
  fetchAudioDuration = audioUrl => {
    return new Promise(resolve => {
      if (!audioUrl) {
        resolve(0); // 空URL返回0
        return;
      }
      const audio = new Audio();
      audio.preload = 'metadata'; // 仅加载元数据（包含时长）
      audio.src = audioUrl;

      // 元数据加载完成时获取时长
      audio.onloadedmetadata = () => {
        // alert(audio.duration);
        setTimeout(() => {
          resolve(audio.duration || 0); // 时长可能为NaN，默认0
          audio.src = ''; // 释放资源
        }, 1000);
      };

      // 加载失败时返回0
      audio.onerror = () => {
        resolve(0);
        audio.src = '';
      };
    });
  };

  getData = async () => {
    // let data = [
    //   {
    //     title: '[三生三世]',
    //     author: '王蓉、萧正楠',
    //     music: [
    //       {
    //         uid: 'PKE7RGvvsXlX3F6nOR2Iis2k2RAB8H38',
    //         url:
    //           'https://static-omni-js4.seasungames.cn/uploads/202511/1762223977971_2005-%E3%80%8A%E4%B8%89%E7%94%9F%E4%B8%89%E4%B8%96%E3%80%8B%EF%BC%88%E7%BD%97%E6%99%93%E9%9F%B3%E4%BD%9C%E6%9B%B2%EF%BC%8C%E7%8E%8B%E8%93%89%E3%80%81%E8%90%A7%E6%AD%A3%E6%A5%A0%E5%90%88%E5%94%B1%EF%BC%89.mp3',
    //         name: '2005-《三生三世》（罗晓音作曲，王蓉、萧正楠合唱）.mp3'
    //       }
    //     ],
    //     categoryName: '音乐',
    //     categoryId: 'sqs2qanbwmbl',
    //     updatedAt: 1762223986,
    //     weight: 0,
    //     publishedAt: 1762223986,
    //     createdAt: 1762223986,
    //     contentLang: 'zh-Hans',
    //     contentId: 'sr274cm79hj5'
    //   },
    //   {
    //     title: '[剑侠情缘]',
    //     author: '韩红',
    //     createdAt: 1762223912,
    //     publishedAt: 1762223912,
    //     contentLang: 'zh-Hans',
    //     contentId: 'sr272bm23gg2',
    //     categoryId: 'sqs2qanbwmbl',
    //     music: [
    //       {
    //         uid: '1mwtzwVL6j1efuiCDMOUsq7tFGbzBCvN',
    //         url:
    //           'https://static-omni-js4.seasungames.cn/uploads/202511/1762223901927_2005-%E3%80%8A%E5%89%91%E4%BE%A0%E6%83%85%E7%BC%98%E3%80%8B%EF%BC%88%E7%BD%97%E6%99%93%E9%9F%B3%E4%BD%9C%E6%9B%B2%EF%BC%8C%E9%9F%A9%E7%BA%A2%E6%BC%94%E5%94%B1%EF%BC%8C%E9%83%AD%E6%95%AC%E6%98%8E%E5%A1%AB%E8%AF%8D%EF%BC%89.mp3',
    //         name: '2005-《剑侠情缘》（罗晓音作曲，韩红演唱，郭敬明填词）.mp3'
    //       }
    //     ],
    //     categoryName: '音乐',
    //     weight: 0,
    //     updatedAt: 1762223912
    //   },
    //   {
    //     weight: 0,
    //     createdAt: 1762223832,
    //     updatedAt: 1762223832,
    //     contentLang: 'zh-Hans',
    //     contentId: 'sr2704otl9fl',
    //     title: '[爱的废墟]',
    //     categoryName: '音乐',
    //     categoryId: 'sqs2qanbwmbl',
    //     author: '俞静',
    //     music: [
    //       {
    //         url:
    //           'https://static-omni-js4.seasungames.cn/uploads/202511/1762223799818_%E3%80%8A%E7%88%B1%E7%9A%84%E5%BA%9F%E5%A2%9F%E3%80%8B%EF%BC%88%E4%BF%9E%E9%9D%99%E6%BC%94%E5%94%B1%EF%BC%89.mp3',
    //         name: '《爱的废墟》（俞静演唱）.mp3',
    //         uid: 'WL2LiRxbDoGfdJ5pjourWzkFGMIMHZ8R'
    //       }
    //     ],
    //     publishedAt: 1762223832
    //   }
    // ];
    // const audioList = [];
    // data.forEach((item, index) => {
    //   audioList.push({
    //     id: index + 1,
    //     title: item.title || '',
    //     singer: item.author || '',
    //     audioUrl: item.music?.[0]?.url || '',
    //     duration: 0 // 初始化为0
    //   });
    // });
    // this.audioListStore.audioList = audioList;
    // this.audioControllerStore.audioList = audioList;
    // if (audioList.length) {
    //   this.audioControllerStore.select(0);
    //   this.delayPlayAudioTimer = setTimeout(() => {
    //     this.audioControllerStore.playAudio(true);
    //   }, 1000);
    //   for (let index = 0; index < audioList.length; index++) {
    //     const item = audioList[index];
    //     // 逐个获取时长，避免同时创建多个Audio实例
    //     const duration = await this.fetchAudioDuration(item.audioUrl);
    //     // 更新时长（利用mobx响应式更新UI）
    //     this.audioListStore.audioList[index].duration = duration;
    //     this.audioControllerStore.audioList[index].duration = duration;
    //   }
    // }

    // return;
    try {
      const res = await getOmniData(AuditionVideoChannelId, [
        {
          dataSourceId: AuditionAudioId || '',
          page: 1,
          perPage: 99
        }
      ]);
      const data = res[AuditionAudioId]?.result?.items || [];
      // console.log(data);

      const audioList = [];
      data.forEach((item, index) => {
        audioList.push({
          id: index + 1,
          title: item.title || '',
          singer: item.author || '',
          audioUrl: item.music?.[0]?.url || '',
          duration: item.song_dur || 0, // 初始化为0
          index: index
        });
      });
      // console.log(audioList);
      // this.audioListStore.audioList = audioList;
      this.audioListStore.audioList = audioList;
      this.audioControllerStore.audioList = audioList;
      if (audioList.length) {
        this.audioControllerStore.select(0);
        this.delayPlayAudioTimer = setTimeout(() => {
          this.audioControllerStore.playAudio(true);
        }, 1000);
        // 调用加载时长方法

        // audioList.forEach(async (item, index) => {
        //   const duration = await this.fetchAudioDuration(item.audioUrl);

        //   this.audioListStore.audioList[index].duration = duration;
        //   this.audioControllerStore.audioList[index].duration = duration;
        // });
      }
    } catch (error) {
      console.log(error);
    }
  };
  test() {
    console.log('test');
    // alert('test');
    // this.getData();
  }
  use() {
    super.use();
    useMount(() => {
      aos.reInit();
      this.getData();
      // setTimeout(() => {
      //   const audioList = [
      //     {
      //       title: '音乐1',
      //       singer: '歌手1、歌手1、歌手1',
      //       audioUrl: 'http://music.163.com/song/media/outer/url?id=447925558.mp3'
      //     },
      //     {
      //       title: '音乐2',
      //       singer: '歌手1、歌手1、歌手1',
      //       audioUrl: 'https://www.cambridgeenglish.org/images/153149-movers-sample-listening-test-vol2.mp3'
      //     },
      //     {
      //       title: '音乐3',
      //       singer: '歌手1、歌手1、歌手1',
      //       audioUrl: 'https://www.cambridgeenglish.org/images/506891-a2-key-for-schools-listening-sample-test.mp3'
      //     },
      //     {
      //       title: '音乐4',
      //       singer: '歌手1、歌手1、歌手1',
      //       audioUrl: 'http://downsc.chinaz.net/Files/DownLoad/sound1/201906/11582.mp3'
      //     },
      //     {
      //       title: '音乐5',
      //       singer: '歌手1、歌手1、歌手1',
      //       audioUrl: 'http://downsc.chinaz.net/files/download/sound1/201206/1638.mp3'
      //     }
      //   ];
      //   this.audioListStore.audioList = audioList;
      //   this.audioControllerStore.audioList = audioList;
      //   if (audioList.length) {
      //     this.audioControllerStore.select(0);
      //     this.delayPlayAudioTimer = setTimeout(() => {
      //       this.audioControllerStore.playAudio(true);
      //     }, 100);
      //   }
      // }, 100);
    });
  }
}

export default AuditionAudioStore;
